function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 65,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 65,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 29h72v72H29z",
  fill: "none"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 88.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.8 49.5h-48v30.16a5.82 5.82 0 005.82 5.66H70a.8.8 0 00.55-.22l16.79-16.78a.74.74 0 00.23-.54V50.27a.76.76 0 00-.77-.77z",
  fill: "#e0e0e2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c6c5ca",
  d: "M52.72 69.6h3.14l2.52-7.9 12.2-12.2h-2.87l-12.2 12.2-2.79 7.9zM86.8 49.5h-2.56v21.93l3.1-3.11a.74.74 0 00.23-.54V50.27a.76.76 0 00-.77-.77z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73.84 70.23H52.55a.77.77 0 110-1.54h21.29a.77.77 0 010 1.54z",
  fill: "#3c5156"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.66 73.57a6.24 6.24 0 011 .08V41.9a.76.76 0 00-.77-.77 6 6 0 00-6 6v31.52a5.89 5.89 0 015.77-5.08z",
  fill: "#919191"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.54 48.77l-4.61-4.62a.8.8 0 00-.55-.22.77.77 0 00-.54.22l-17 17 5.76 5.65 16.94-16.95a.76.76 0 000-1.08z",
  fill: "#ffd039"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.48 64.75l2.12 2 16.94-16.9a.76.76 0 000-1.08L79 47.23z",
  fill: "#ffa304"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.81 61.18a.92.92 0 00-.16.27l-2.51 7.12a.77.77 0 00.72 1 .75.75 0 00.26 0L63.25 67a.84.84 0 00.34-.25z",
  fill: "#ffc89f"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.86 69.6a.75.75 0 00.26 0l7.13-2.6a.84.84 0 00.34-.25l-2.11-2-5.71 2-.63 1.78a.77.77 0 00.72 1z",
  fill: "#f7b081"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.86 69.6a.75.75 0 00.26 0l4.49-1.6-3.89-3.9-1.58 4.47a.77.77 0 00.72 1z",
  fill: "#3c5156"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.46 65.83l-2.69 1-.63 1.78a.77.77 0 00.72 1 .75.75 0 00.26 0L60.61 68z",
  fill: "#304144"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M83 46.27l-4.62-4.62a.76.76 0 00-1.08 0l-3 3L80 50.4l3-3a.8.8 0 00.22-.55.77.77 0 00-.22-.58z",
  fill: "#ff6137"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.92 48.31l.72.73L80 50.4l3-3a.8.8 0 00.22-.55.77.77 0 00-.22-.54l-1.5-1.58z",
  fill: "#e04f32"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.11 42l-2.39-2.38a2.34 2.34 0 00-3.32 0l-1.52 1.52-.54.54-.56.56 5.72 5.66.81-.82 1.8-1.79a2.33 2.33 0 00.68-1.66 2.36 2.36 0 00-.68-1.63z",
  fill: "#546f7a"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#475d63",
  d: "M76.79 42.2l-.01.01 1.71 1.7-1.7-1.71zm8.32-.2l-1.89-1.88a2.37 2.37 0 01.48 1.43 2.4 2.4 0 01-.7 1.65L81.22 45l-.81.81 2.09 2.09.81-.82 1.8-1.79a2.33 2.33 0 00.68-1.66 2.36 2.36 0 00-.68-1.63z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.71 63.45a.77.77 0 00-.84.17L63.7 89.79a.77.77 0 00-.16.84.78.78 0 00.71.47h26.17a.76.76 0 00.76-.77V64.16a.76.76 0 00-.47-.71zM76.46 84.88l8.4-8.4v8.4z",
  fill: "#ffca10"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M90.71 63.45a.77.77 0 00-.84.17l-2 2V91.1h2.57a.76.76 0 00.76-.77V64.16a.76.76 0 00-.49-.71z",
  fill: "#ffa304"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.18 72.8h-3a.77.77 0 000 1.54h3zm0 3.85h-3a.77.77 0 100 1.54h3zm0 3.86h-3a.77.77 0 100 1.53h3zm0 3.85h-3a.77.77 0 100 1.54h3z",
  fill: "#c96e14"
});

var SvgIcDesign = function SvgIcDesign(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzAgMTMwIj48dGl0bGU+aWMtMTUwLWxlc3NvbnM8L3RpdGxlPjxwYXRoIGQ9Ik0wLTJIMTMwVjEyOEgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6bm9uZSIvPjxjaXJjbGUgaWQ9ImIiIGN4PSI2NSIgY3k9IjY1IiByPSI1NiIvPjxjaXJjbGUgaWQ9ImItMiIgZGF0YS1uYW1lPSJiIiBjeD0iNjUiIGN5PSI2NSIgcj0iNTYiIHN0eWxlPSJmaWxsOiNmZmY7c3Ryb2tlOiMxMjEyM2I7c3Ryb2tlLXdpZHRoOjJweCIvPjxwYXRoIGQ9Ik0yOSwyN2g3MlY5OUgyOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOm5vbmUiLz48cGF0aCBkPSJNODUsODYuNTFhMy40MSwzLjQxLDAsMCwxLTIuNDctMWwtMTgtMTcuOTVhMy41LDMuNSwwLDAsMS0xLTIuNDgsMy41LDMuNSwwLDAsMSw2LTIuNDdsMTgsMThhMy40MywzLjQzLDAsMCwxLDEsMi40NywzLjQ4LDMuNDgsMCwwLDEtMy41LDMuNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2ZmZiIvPjxwYXRoIGQ9Ik04Ni44LDQ3LjVoLTQ4czAsMjguNTgsMCwzMC4xNnYwYTUuODIsNS44MiwwLDAsMCw1LjgyLDUuNjZINzBhLjguOCwwLDAsMCwuNTUtLjIyTDg3LjM0LDY2LjMyYS43NC43NCwwLDAsMCwuMjMtLjU0VjQ4LjI3QS43Ni43NiwwLDAsMCw4Ni44LDQ3LjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojZTBlMGUyIi8+PHBvbHlnb24gcG9pbnRzPSI1Mi43MiA2OS42IDU1Ljg2IDY5LjYgNTguMzggNjEuNyA3MC41OCA0OS41IDY3LjcxIDQ5LjUgNTUuNTEgNjEuNyA1Mi43MiA2OS42IiBzdHlsZT0iZmlsbDojYzZjNWNhIi8+PHBhdGggZD0iTTg2LjgsNDcuNUg4NC4yNFY2OS40M2wzLjEtMy4xMWEuNzQuNzQsMCwwLDAsLjIzLS41NFY0OC4yN0EuNzYuNzYsMCwwLDAsODYuOCw0Ny41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2M2YzVjYSIvPjxwYXRoIGQ9Ik03My44NCw2OC4yM0g1Mi41NWEuNzcuNzcsMCwxLDEsMC0xLjU0SDczLjg0YS43Ny43NywwLDAsMSwwLDEuNTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojM2M1MTU2Ii8+PHBhdGggZD0iTTQ0LjY2LDcxLjU3YTYuMjQsNi4yNCwwLDAsMSwxLC4wOFYzOS45YS43Ni43NiwwLDAsMC0uNzctLjc3LDYsNiwwLDAsMC02LDZWNzYuNjVBNS44OSw1Ljg5LDAsMCwxLDQ0LjY2LDcxLjU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6IzkxOTE5MSIvPjxwYXRoIGQ9Ik04MC41NCw0Ni43N2wtNC42MS00LjYyYS44LjgsMCwwLDAtLjU1LS4yMi43Ny43NywwLDAsMC0uNTQuMjJsLTE3LDE3LDAsMEw2My42LDY0LjgsODAuNTQsNDcuODVBLjc2Ljc2LDAsMCwwLDgwLjU0LDQ2Ljc3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2ZmZDAzOSIvPjxwYXRoIGQ9Ik02MS40OCw2Mi43NWwyLjEyLDJMODAuNTQsNDcuODVhLjc2Ljc2LDAsMCwwLDAtMS4wOEw3OSw0NS4yM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiNmZmEzMDQiLz48cGF0aCBkPSJNNTcuODEsNTkuMThhLjkyLjkyLDAsMCwwLS4xNi4yN2wtMi41MSw3LjEyYS43Ny43NywwLDAsMCwuNzIsMSwuNzUuNzUsMCwwLDAsLjI2LDBMNjMuMjUsNjVhLjg0Ljg0LDAsMCwwLC4zNC0uMjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojZmZjODlmIi8+PHBhdGggZD0iTTU1Ljg2LDY3LjZhLjc1Ljc1LDAsMCwwLC4yNiwwTDYzLjI1LDY1YS44NC44NCwwLDAsMCwuMzQtLjI1bC0yLjExLTItNS43MSwyLS42MywxLjc4YS43Ny43NywwLDAsMCwuNzIsMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiNmN2IwODEiLz48cGF0aCBkPSJNNTUuODYsNjcuNmEuNzUuNzUsMCwwLDAsLjI2LDBMNjAuNjEsNjYsNTYuNzIsNjIuMWwtMS41OCw0LjQ3YS43Ny43NywwLDAsMCwuNzIsMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiMzYzUxNTYiLz48cGF0aCBkPSJNNTguNDYsNjMuODNsLTIuNjksMS0uNjMsMS43OGEuNzcuNzcsMCwwLDAsLjcyLDEsLjc1Ljc1LDAsMCwwLC4yNiwwTDYwLjYxLDY2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6IzMwNDE0NCIvPjxwYXRoIGQ9Ik04Myw0NC4yN2wtNC42Mi00LjYyYS43Ni43NiwwLDAsMC0xLjA4LDBsLTMsM0w4MCw0OC40bDMtM2EuOC44LDAsMCwwLC4yMi0uNTVBLjc3Ljc3LDAsMCwwLDgzLDQ0LjI3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2ZmNjEzNyIvPjxwYXRoIGQ9Ik03Ny45Miw0Ni4zMWwuNzIuNzNMODAsNDguNGwzLTNhLjguOCwwLDAsMCwuMjItLjU1Ljc3Ljc3LDAsMCwwLS4yMi0uNTRMODEuNSw0Mi43M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiNlMDRmMzIiLz48cGF0aCBkPSJNODUuMTEsNDBsLTIuMzktMi4zOGEyLjM0LDIuMzQsMCwwLDAtMy4zMiwwbC0xLjUyLDEuNTItLjU0LjU0LS41Ni41Nkw4Mi41LDQ1LjlsLjgxLS44MiwxLjgtMS43OWEyLjMzLDIuMzMsMCwwLDAsLjY4LTEuNjZBMi4zNiwyLjM2LDAsMCwwLDg1LjExLDQwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6IzU0NmY3YSIvPjxwb2x5Z29uIHBvaW50cz0iNzYuNzkgNDIuMiA3Ni43OCA0Mi4yMSA3OC40OSA0My45MSA3Ni43OSA0Mi4yIiBzdHlsZT0iZmlsbDojNDc1ZDYzIi8+PHBhdGggZD0iTTg1LjExLDQwbC0xLjg5LTEuODhhMi4zNywyLjM3LDAsMCwxLC40OCwxLjQzQTIuNCwyLjQsMCwwLDEsODMsNDEuMkw4MS4yMiw0M2wtLjgxLjgxTDgyLjUsNDUuOWwuODEtLjgyLDEuOC0xLjc5YTIuMzMsMi4zMywwLDAsMCwuNjgtMS42NkEyLjM2LDIuMzYsMCwwLDAsODUuMTEsNDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojNDc1ZDYzIi8+PHBhdGggZD0iTTkwLjcxLDYxLjQ1YS43Ny43NywwLDAsMC0uODQuMTdMNjMuNyw4Ny43OWEuNzcuNzcsMCwwLDAtLjE2Ljg0Ljc4Ljc4LDAsMCwwLC43MS40N0g5MC40MmEuNzYuNzYsMCwwLDAsLjc2LS43N1Y2Mi4xNkEuNzYuNzYsMCwwLDAsOTAuNzEsNjEuNDVaTTc2LjQ2LDgyLjg4bDguNC04LjR2OC40WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2ZmY2ExMCIvPjxwYXRoIGQ9Ik05MC43MSw2MS40NWEuNzcuNzcsMCwwLDAtLjg0LjE3bC0yLDJWODkuMWgyLjU3YS43Ni43NiwwLDAsMCwuNzYtLjc3VjYyLjE2QS43Ni43NiwwLDAsMCw5MC43MSw2MS40NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiNmZmEzMDQiLz48cGF0aCBkPSJNOTEuMTgsNzAuOGgtM2EuNzcuNzcsMCwwLDAsMCwxLjU0aDNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojYzk2ZTE0Ii8+PHBhdGggZD0iTTkxLjE4LDc0LjY1aC0zYS43Ny43NywwLDEsMCwwLDEuNTRoM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiIHN0eWxlPSJmaWxsOiNjOTZlMTQiLz48cGF0aCBkPSJNOTEuMTgsNzguNTFoLTNhLjc3Ljc3LDAsMSwwLDAsMS41M2gzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAyKSIgc3R5bGU9ImZpbGw6I2M5NmUxNCIvPjxwYXRoIGQ9Ik05MS4xOCw4Mi4zNmgtM2EuNzcuNzcsMCwxLDAsMCwxLjU0aDNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDIpIiBzdHlsZT0iZmlsbDojYzk2ZTE0Ii8+PC9zdmc+";
export { SvgIcDesign as ReactComponent };